import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  static counter = 0

  add(event) {
    event.preventDefault()
    // Timestamp plus a counter: two clicks inside one millisecond must not
    // produce the same nested index (Rack keeps only the last of two).
    const index = `${Date.now()}${this.constructor.counter++}`
    const template = event.params?.kind === "fuel" ? this.element.querySelector("template[data-fuel-template]") : this.templateTarget
    const content = template.innerHTML.replace(/NEW_RECORD/g, index)
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
